import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsEvent, TealiumAnalyticsService } from '@ddt-web/analytics';

@Component({
	selector: 'ac-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})
export class SearchComponent {
	@Input() public placeholder: string = this.contentService.get('SEARCH_PLACEHOLDER', 'Search for a ticker');
	@Input() public searchFormControl: UntypedFormControl;

	constructor(private contentService: ContentService, private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public triggerAnalytics(): void {
		const tealiumEvent = new TealiumAnalyticsEvent(`search for fund:${this.searchFormControl.value}`, {});
		this.tealiumAnalyticsService.trackEventTealium(tealiumEvent);
	}
}
